import { Avatar, Button, ButtonProps, Menu, MenuItem, Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { useLogin, useSetUser, useUser } from 'components/user/UserProvider';
import React from 'react';
import { signOut } from 'services/AccountService';

const useStyles = makeStyles((theme: Theme) => ({
  navLink: {
    color: theme.palette.secondary.main,
  },
}));

interface Props {
  ButtonProps?: ButtonProps;
}

const LoginButton: React.FC<Props> = ({ ButtonProps = {} }) => {
  const user = useUser();
  const setUser = useSetUser();

  const handleLogin = useLogin();

  // Handle the profile menu
  const [profileMenuEl, setProfileMenuEl] = React.useState<Element | null>(null);
  function handleProfileClick(event: React.MouseEvent) {
    setProfileMenuEl(event.currentTarget);
  }

  function handleProfileMenuClose() {
    setProfileMenuEl(null);
  }

  function handleLogoutClick() {
    signOut();
    setUser(null);
    handleProfileMenuClose();
  }

  const classes = useStyles({});

  return user ? (
    <>
      <Button id="profile-button" onClick={handleProfileClick} className={classes.navLink}>
        <Avatar alt={user.displayName ?? 'Anonymous'} src={user.photoURL ?? ''} />
      </Button>
      <Menu
        id="profile-menu"
        anchorEl={profileMenuEl}
        keepMounted
        open={Boolean(profileMenuEl)}
        onClose={handleProfileMenuClose}
      >
        <MenuItem onClick={handleLogoutClick}>Logout</MenuItem>
      </Menu>
    </>
  ) : (
    <Button
      id="login-button"
      onClick={handleLogin}
      className={classes.navLink}
      variant="text"
      {...ButtonProps}
    >
      Login
    </Button>
  );
};

export default LoginButton;
